function deferFilterjQuery() {
      // On load/reload
      var pt_on_load = function() {
        // Accordion
        

      	// Search
        $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

      	// Drop downs
        $('.pt-display-dropdown').each(function( index ) {
            $(this).find('h4').after($(this).find('.filter-clear'));
        });

        $('.pt-display-dropdown .scroll-content').each(function( index ) {
            if($(this).find('li.selected').length) {
                var selected = $.map(
                    $(this).find('li.selected a'),
                        function(element){
                            return $(element).text();
                        }
                  ).join(", ");

              if (selected.length < 30) {
                $(this).before('<div class="menu-trigger">' + selected +'</div>');
              } else {
                 $(this).before('<div class="menu-trigger">' + $(this).find('li.selected').length + ' Selected </div>');
              }
            }
            else {
                $(this).before('<div class="menu-trigger">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
            }                
        });

      	// View more
        
      }

      

    setTimeout(function () {
      createFilterTooltips();
    }, 1500);

      $('.filter-menu li a').attr('title', function() { return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();});

      pt_on_load();

      // Mobile filter button
      
      $(document).on('click', '.filter-menu .pt-mobile-header a', function(e){
        if(e.handled !== true) {
          if ($('.pt-nav-toggle').hasClass('active')) {
            $('.filter-menu').removeClass('pt-expand');            
          } else {
            $('.filter-menu').addClass('pt-expand');            
          }
          $('.pt-nav-toggle').toggleClass('active');
          e.preventDefault();
          e.handled = true;
        }
      });

      

      // Accordion
      

      // Search
      $(document).on('keyup', '.filter-group input.fm-search-box', function () {
        var value = this.value.toLowerCase();
        $(this).closest('.filter-group').find('li').each(function () {
          if ($(this).text().toLowerCase().search(value) > -1) {
            $(this).show(100);
          } else {
            $(this).hide(100);
          }
        });
      });

      // Drop downs
      $(document).on('click','.pt-display-dropdown .menu-trigger',function() {
        $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
        $(this).next('.scroll-content').slideToggle('fast');
      });

      $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
        $(this).slideUp('fast');
      });

      // Apply button
      

      // Ajax
      
        $body = $("body");
        
        $(document).pjax('div.collection-wrapper .filter-group a, div.collection-wrapper .pagination a', 'div.collection-wrapper', { fragment: 'div.collection-wrapper', timeout: 10000, scrollTo: false, push: true });
        $(document).on('pjax:click', function(xhr, options){
            var url = options.url;
            var url = url.replace('?view=ajax','').replace('&view=ajax','');
            if( url.indexOf('?') != -1 ){ 
              options.url = url + '&view=ajax';
            } else {
              options.url = url + '?view=ajax';
            }
        });
        $(document).on('pjax:beforeReplace', function( contents ){
            var href =  window.location.href.replace('?view=ajax','').replace('&view=ajax','');
            window.history.replaceState(null, "", href);
        });
        $(document).on('pjax:start', function(){
            $body.addClass("pt-ajax-loading");
            $('div.collection-wrapper').fadeTo('slow', 0.8);

        })
        $(document).on('pjax:end', function(){
            $body.removeClass("pt-ajax-loading");
            createFilterTooltips();
            $('div.collection-wrapper').fadeTo('fast', 1);
            pt_on_load();
            ;
            $(document).find('.filter-group li.collection-container a').each(function(){
                var href = $(this).attr('href');
                if( href != undefined ){
                    href = href.replace('?view=ajax','').replace('&view=ajax','');
                    $(this).attr('href',href);
                }
                
            })
          
          var filter_count = $('.has_group_selected .selected').length,
              filter_clear_all = $('.filter-clear-all');

          if(filter_count > 1) {            
            $('.filter-count').text('(' + (filter_count - 1) + ')');
            filter_clear_all.addClass('showing');
          } else {
            filter_clear_all.removeClass('showing');
          }   
          
          // Scroll to the top:
          var offset = $(window).innerWidth() < 1024 ? $('#header-mobile').outerHeight() : $('#nav-desktop').outerHeight(); // Fixed header height
          var $target = $('.collection-toolbar').length ? $('.collection-toolbar') : $('.collection-wrapper');
          var scrollTop = $target.offset().top - offset;
          $('html, body').animate({scrollTop: scrollTop}, 400);
        });                    
      

}

deferFilterjQuery();

function createFilterTooltips() {
    // Grab each Filter type by title
    const $bedSize = $('.filter-menu [class*="bed-size"] h4');
    const $loftHeight = $('.filter-menu [class*="loft-height"] h4');
    const $bunkHeight = $('.filter-menu [class*="bunk-height"] h4');
    const $entryType = $('.filter-menu [class*="entry-type"] h4');

    // Create DOM for each Filter type tooltip
    const bedSizeTooltip = '<span class="tooltip" data-tooltip-content="#tooltip_content_bed_size">?</span><div class="tooltip_templates"><span id="tooltip_content_bed_size"><ul><li><strong>Twin:</strong> 42.5” x 80”, Fits standard twin mattress</li><li><strong>Twin XL:</strong> 42.5” x 84”, Requires twin XL mattress</li><li><strong>Full:</strong> 57.5” x 80”, Fits standard full mattress</li><li><strong>Full XL:</strong> 57.5” x 84”, Requires full XL mattress</li><li><strong>Queen:</strong> 64” x 84”, Fits standard queen mattress</li></ul></span></div>';

    const loftHeightTooltip = '<span class="tooltip" data-tooltip-content="#tooltip_content_loft_height">?</span><div class="tooltip_templates"><span id="tooltip_content_loft_height"><ul><li><strong>Low:</strong> H 50.75”, Underbed 33.5”</li><li><strong>Mid:</strong> H 61.5”, Underbed 44.25”</li><li><strong>High:</strong> H 71”, Underbed 52.5”</li><li><strong>Ultra-High:</strong> H 76.5”, Underbed 58”</li></ul></span></div>';

    const bunkHeightTooltip = '<span class="tooltip" data-tooltip-content="#tooltip_content_bunk_height">?</span><div class="tooltip_templates"><span id="tooltip_content_bunk_height"><ul><li><strong>Low:</strong> H 61.5”, Underbed 32.25”</li><li><strong>Mid:</strong> H 66.25”, Underbed 37”</li><li><strong>High:</strong> H 71”, Underbed 41.5”</li></ul></span></div>';

    const entryTypeTooltip = '<span class="tooltip" data-tooltip-content="#tooltip_content_entry_type">?</span><div class="tooltip_templates"><span id="tooltip_content_entry_type"><ul><li><strong>Ladder:</strong> Straight or Angled, Front or End of Bed</li><li><strong>Staircase:</strong> Easy climbing. Steps double as drawers.</li><li><strong>Slide Platform:</strong> Slide + Bed entrance as one.</li></ul></span></div>';

    // const filterTitles = $('.ss__facet__header');
    // filterTitles.each(function(){
    //   console.log($(this).text());
    //   if ($(this).text() == 'Bed Size') {
    //     console.log('add tooltip');
    //     $(this).append(bedSizeTooltip);
    //   }
    // });
    // console.log(filterTitles);
    


    // Insert tooltip DOM for each Filter type
    if ($bedSize.find('.tooltip').length == 0) {
    $bedSize.append(bedSizeTooltip);
    }

    if ($loftHeight.find('.tooltip').length == 0) {
    $loftHeight.append(loftHeightTooltip);
    }

    if ($bunkHeight.find('.tooltip').length == 0) {
    $bunkHeight.append(bunkHeightTooltip);
    }

    if ($entryType.find('.tooltip').length == 0) {
    $entryType.append(entryTypeTooltip);
    }

    // Init Tooltipster
    var event = new CustomEvent('initTooltipster', {});
    document.dispatchEvent(event);
}